import {
  faDesktop,
  faUniversalAccess,
} from "@fortawesome/free-solid-svg-icons";
import { faMoon, faSun } from "@fortawesome/pro-solid-svg-icons";
import mixpanel from "mixpanel-browser";
import React from "react";

import { useThemeMode } from "../../hooks";
import { DSDropdown } from "../design-system/molecules";

const THEME_OPTIONS = [
  { label: "System", value: "system" },
  { label: "Light", value: "light" },
  { label: "Dark", value: "dark" },
  { label: "Accessible Light", value: "accessible-light" },
  { label: "Accessible Dark", value: "accessible-dark" },
];

export default function DarkModeToggle() {
  const [themeMode, setThemeMode] = useThemeMode();

  return (
    <div className="mx-xs mb-xs self-center">
      <DSDropdown
        options={THEME_OPTIONS}
        value={themeMode}
        onChange={(value) => {
          setThemeMode(value);
          mixpanel.track("Updated Account Setting", {
            settingName: "Theme Mode",
            settingKey: "dark-mode-enabled",
            settingValue: value,
          });
        }}
        leadingIcon={
          themeMode === "system"
            ? faDesktop
            : themeMode === "light"
              ? faSun
              : themeMode === "accessible-light" ||
                  themeMode === "accessible-dark"
                ? faUniversalAccess
                : faMoon
        }
        dataTestId="theme-mode-select"
      />
    </div>
  );
}
